
const LAYOUT_TYPE = process.env.REACT_APP_LAYOUT_TYPE

const RETESCAKE_LAYOUT = "Rétescake"

export {LAYOUT_TYPE, RETESCAKE_LAYOUT};
